// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MODELS COMMON - Design Tokens & Utilities
   Shared foundation for all Models module CSS
   ============================================ */

/* ============================================
   CSS CUSTOM PROPERTIES (Design Tokens)
   ============================================ */
:root {
  /* === Brand Colors === */
  --color-primary: #8B5CF6;
  --color-primary-light: #C084FC;
  --color-primary-muted: #c4b5fd;
  --color-accent-cyan: #0ae6d3;
  --color-accent-orange: #F97316;
  --color-accent-yellow: #eab308;

  /* === Semantic Colors === */
  --color-positive: #34d399;
  --color-positive-vivid: #10B981;
  --color-negative: #f87171;
  --color-negative-vivid: #EF4444;
  --color-warning: #fbbf24;
  --color-warning-vivid: #F59E0B;

  /* === Chart / Data Visualization Colors === */
  --color-chart-blue: #3B82F6;
  --color-chart-green: #10B981;
  --color-chart-amber: #F59E0B;
  --color-chart-red: #EF4444;
  --color-chart-purple: #8B5CF6;
  --color-chart-pink: #EC4899;
  --color-chart-teal: #14B8A6;
  --color-chart-orange: #F97316;
  --color-chart-indigo: #6366F1;
  --color-chart-lime: #84CC16;
  --color-chart-cyan: #06B6D4;
  --color-chart-violet: #A855F7;

  /* === Text Colors === */
  --color-text-primary: #ffffff;
  --color-text-secondary: rgba(255, 255, 255, 0.85);
  --color-text-muted: rgba(255, 255, 255, 0.65);
  --color-text-dim: rgba(255, 255, 255, 0.5);
  --color-text-faint: rgba(255, 255, 255, 0.4);
  --color-text-ghost: rgba(255, 255, 255, 0.3);
  --color-text-disabled: #666666;
  --color-text-light-gray: #D1D5DB;
  --color-text-mid-gray: #9CA3AF;
  --color-text-bright-gray: #E5E7EB;

  /* === Surface / Background Colors === */
  --surface-card: rgba(30, 30, 50, 0.6);
  --surface-card-hover: rgba(40, 40, 60, 0.7);
  --surface-subtle: rgba(255, 255, 255, 0.03);
  --surface-subtle-hover: rgba(255, 255, 255, 0.05);
  --surface-input: rgba(0, 0, 0, 0.2);
  --surface-input-focus: rgba(0, 0, 0, 0.3);
  --surface-glass: rgba(51, 51, 51, 0.2);
  --surface-overlay: rgba(30, 30, 40, 0.6);
  --surface-dark-gradient-start: #1e293b;
  --surface-dark-gradient-end: #0f172a;

  /* === Border Colors === */
  --border-default: rgba(255, 255, 255, 0.1);
  --border-subtle: rgba(255, 255, 255, 0.08);
  --border-faint: rgba(255, 255, 255, 0.05);
  --border-medium: rgba(255, 255, 255, 0.15);
  --border-strong: rgba(255, 255, 255, 0.3);
  --border-glass: rgba(255, 255, 255, 0.4);
  --border-primary: rgba(139, 92, 246, 0.4);
  --border-primary-hover: rgba(139, 92, 246, 0.6);
  --border-primary-light: rgba(139, 92, 246, 0.3);
  --border-primary-subtle: rgba(139, 92, 246, 0.15);
  --border-cyan: rgba(10, 230, 211, 0.3);
  --border-error: rgba(239, 68, 68, 0.3);
  --border-error-subtle: rgba(220, 38, 38, 0.3);

  /* === Spacing === */
  --space-xs: 0.25rem;
  --space-sm: 0.5rem;
  --space-md: 0.75rem;
  --space-lg: 1rem;
  --space-xl: 1.5rem;
  --space-2xl: 2rem;

  /* === Border Radius === */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  --radius-2xl: 20px;
  --radius-3xl: 24px;
  --radius-pill: 40px;
  --radius-circle: 50%;

  /* === Typography === */
  --font-size-xs: 0.65rem;
  --font-size-sm: 0.75rem;
  --font-size-base: 0.8rem;
  --font-size-md: 0.85rem;
  --font-size-lg: 0.9rem;
  --font-size-xl: 1rem;
  --font-size-2xl: 1.1rem;
  --font-size-3xl: 1.25rem;

  /* === Tooltip === */
  --tooltip-bg: rgba(30, 35, 50, 0.98);
  --tooltip-border: rgba(75, 85, 99, 0.3);
  --tooltip-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);

  /* === Transitions === */
  --transition-fast: all 0.2s ease;
  --transition-normal: all 0.3s ease;
}

/* ============================================
   LAYOUT UTILITIES
   ============================================ */
.u-flex {
  display: flex;
}

.u-flex-col {
  display: flex;
  flex-direction: column;
}

.u-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.u-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.u-flex-wrap {
  flex-wrap: wrap;
}

.u-items-center {
  align-items: center;
}

.u-gap-xs {
  gap: var(--space-xs);
}

.u-gap-sm {
  gap: var(--space-sm);
}

.u-gap-md {
  gap: var(--space-md);
}

.u-gap-lg {
  gap: var(--space-lg);
}

.u-gap-xl {
  gap: var(--space-xl);
}

/* ============================================
   TEXT UTILITIES
   ============================================ */
.u-text-center {
  text-align: center;
}

.u-text-right {
  text-align: right;
}

.u-text-muted {
  color: var(--color-text-muted);
}

.u-text-dim {
  color: var(--color-text-dim);
}

.u-text-faint {
  color: var(--color-text-faint);
}

.u-text-uppercase {
  text-transform: uppercase;
}

.u-font-500 {
  font-weight: 500;
}

.u-font-600 {
  font-weight: 600;
}

/* ============================================
   DISPLAY UTILITIES
   ============================================ */
.u-hidden {
  display: none;
}

/* ============================================
   STATE UTILITIES
   (Empty, loading, and error states used
   across multiple Models module components)
   ============================================ */
.u-empty-state {
  padding: 20px;
  text-align: center;
  color: var(--color-text-disabled);
}

.u-error-state {
  padding: 40px;
  text-align: center;
  color: var(--color-text-disabled);
}

/* ============================================
   CHART TOOLTIP
   (Shared across ModelMainChart and potentially
   other chart components)
   ============================================ */
.chart-tooltip {
  background: var(--tooltip-bg);
  border: 1px solid var(--tooltip-border);
  border-radius: var(--radius-md);
  padding: 8px 12px;
  box-shadow: var(--tooltip-shadow);
  color: var(--color-text-primary);
  font-size: 13px;
  min-width: 280px;
}

.chart-tooltip__header {
  margin-bottom: 6px;
}

.chart-tooltip__date {
  color: var(--color-text-mid-gray);
  font-size: 11px;
  margin-top: 2px;
}

.chart-tooltip__row {
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
}

.chart-tooltip__label {
  color: var(--color-text-mid-gray);
}

.chart-tooltip__value {
  font-weight: 500;
  font-size: 14px;
}

.chart-tooltip__value--open {
  color: var(--color-chart-blue);
}

.chart-tooltip__value--high {
  color: var(--color-chart-green);
}

.chart-tooltip__value--low {
  color: var(--color-chart-red);
}

.chart-tooltip__value--close {
  color: var(--color-chart-purple);
}

.chart-tooltip__value--volume {
  color: var(--color-chart-cyan);
}

.chart-tooltip__separator {
  margin: 8px 0 4px 0;
  padding-top: 8px;
  border-top: 1px solid var(--tooltip-border);
}

.chart-tooltip__main-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.chart-tooltip__main-row--bordered {
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(75, 85, 99, 0.2);
}

.chart-tooltip__name-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.chart-tooltip__value-group {
  text-align: right;
  margin-left: 12px;
}

.chart-tooltip__indicator {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-circle);
  flex-shrink: 0;
}

.chart-tooltip__name {
  color: var(--color-text-bright-gray);
  font-size: 13px;
  font-weight: 400;
}

/* ============================================
   DRAG STATE
   (Shared drag-active class for drag-and-drop
   interactions in ModelBuilder)
   ============================================ */
.drag-active {
  border-color: var(--color-primary) !important;
  background: rgba(139, 92, 246, 0.1) !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/models-common.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD;;iDAEiD;AACjD;EACE,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;;EAE9B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,8BAA8B;;EAE9B,8CAA8C;EAC9C,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;;EAE7B,wBAAwB;EACxB,6BAA6B;EAC7B,iDAAiD;EACjD,6CAA6C;EAC7C,0CAA0C;EAC1C,4CAA4C;EAC5C,4CAA4C;EAC5C,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;;EAEjC,wCAAwC;EACxC,qCAAqC;EACrC,2CAA2C;EAC3C,2CAA2C;EAC3C,iDAAiD;EACjD,mCAAmC;EACnC,yCAAyC;EACzC,sCAAsC;EACtC,wCAAwC;EACxC,sCAAsC;EACtC,oCAAoC;;EAEpC,0BAA0B;EAC1B,0CAA0C;EAC1C,0CAA0C;EAC1C,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;EACxC,yCAAyC;EACzC,+CAA+C;EAC/C,+CAA+C;EAC/C,iDAAiD;EACjD,sCAAsC;EACtC,sCAAsC;EACtC,6CAA6C;;EAE7C,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;;EAEjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;;EAEpB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;;EAExB,oBAAoB;EACpB,oCAAoC;EACpC,uCAAuC;EACvC,mDAAmD;;EAEnD,wBAAwB;EACxB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;;iDAEiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;AACf;;AAEA;;;;iDAIiD;AACjD;EACE,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;;;iDAIiD;AACjD;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,+BAA+B;EAC/B,iBAAiB;EACjB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;iDAIiD;AACjD;EACE,6CAA6C;EAC7C,8CAA8C;AAChD","sourcesContent":["/* ============================================\n   MODELS COMMON - Design Tokens & Utilities\n   Shared foundation for all Models module CSS\n   ============================================ */\n\n/* ============================================\n   CSS CUSTOM PROPERTIES (Design Tokens)\n   ============================================ */\n:root {\n  /* === Brand Colors === */\n  --color-primary: #8B5CF6;\n  --color-primary-light: #C084FC;\n  --color-primary-muted: #c4b5fd;\n  --color-accent-cyan: #0ae6d3;\n  --color-accent-orange: #F97316;\n  --color-accent-yellow: #eab308;\n\n  /* === Semantic Colors === */\n  --color-positive: #34d399;\n  --color-positive-vivid: #10B981;\n  --color-negative: #f87171;\n  --color-negative-vivid: #EF4444;\n  --color-warning: #fbbf24;\n  --color-warning-vivid: #F59E0B;\n\n  /* === Chart / Data Visualization Colors === */\n  --color-chart-blue: #3B82F6;\n  --color-chart-green: #10B981;\n  --color-chart-amber: #F59E0B;\n  --color-chart-red: #EF4444;\n  --color-chart-purple: #8B5CF6;\n  --color-chart-pink: #EC4899;\n  --color-chart-teal: #14B8A6;\n  --color-chart-orange: #F97316;\n  --color-chart-indigo: #6366F1;\n  --color-chart-lime: #84CC16;\n  --color-chart-cyan: #06B6D4;\n  --color-chart-violet: #A855F7;\n\n  /* === Text Colors === */\n  --color-text-primary: #ffffff;\n  --color-text-secondary: rgba(255, 255, 255, 0.85);\n  --color-text-muted: rgba(255, 255, 255, 0.65);\n  --color-text-dim: rgba(255, 255, 255, 0.5);\n  --color-text-faint: rgba(255, 255, 255, 0.4);\n  --color-text-ghost: rgba(255, 255, 255, 0.3);\n  --color-text-disabled: #666666;\n  --color-text-light-gray: #D1D5DB;\n  --color-text-mid-gray: #9CA3AF;\n  --color-text-bright-gray: #E5E7EB;\n\n  /* === Surface / Background Colors === */\n  --surface-card: rgba(30, 30, 50, 0.6);\n  --surface-card-hover: rgba(40, 40, 60, 0.7);\n  --surface-subtle: rgba(255, 255, 255, 0.03);\n  --surface-subtle-hover: rgba(255, 255, 255, 0.05);\n  --surface-input: rgba(0, 0, 0, 0.2);\n  --surface-input-focus: rgba(0, 0, 0, 0.3);\n  --surface-glass: rgba(51, 51, 51, 0.2);\n  --surface-overlay: rgba(30, 30, 40, 0.6);\n  --surface-dark-gradient-start: #1e293b;\n  --surface-dark-gradient-end: #0f172a;\n\n  /* === Border Colors === */\n  --border-default: rgba(255, 255, 255, 0.1);\n  --border-subtle: rgba(255, 255, 255, 0.08);\n  --border-faint: rgba(255, 255, 255, 0.05);\n  --border-medium: rgba(255, 255, 255, 0.15);\n  --border-strong: rgba(255, 255, 255, 0.3);\n  --border-glass: rgba(255, 255, 255, 0.4);\n  --border-primary: rgba(139, 92, 246, 0.4);\n  --border-primary-hover: rgba(139, 92, 246, 0.6);\n  --border-primary-light: rgba(139, 92, 246, 0.3);\n  --border-primary-subtle: rgba(139, 92, 246, 0.15);\n  --border-cyan: rgba(10, 230, 211, 0.3);\n  --border-error: rgba(239, 68, 68, 0.3);\n  --border-error-subtle: rgba(220, 38, 38, 0.3);\n\n  /* === Spacing === */\n  --space-xs: 0.25rem;\n  --space-sm: 0.5rem;\n  --space-md: 0.75rem;\n  --space-lg: 1rem;\n  --space-xl: 1.5rem;\n  --space-2xl: 2rem;\n\n  /* === Border Radius === */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 16px;\n  --radius-2xl: 20px;\n  --radius-3xl: 24px;\n  --radius-pill: 40px;\n  --radius-circle: 50%;\n\n  /* === Typography === */\n  --font-size-xs: 0.65rem;\n  --font-size-sm: 0.75rem;\n  --font-size-base: 0.8rem;\n  --font-size-md: 0.85rem;\n  --font-size-lg: 0.9rem;\n  --font-size-xl: 1rem;\n  --font-size-2xl: 1.1rem;\n  --font-size-3xl: 1.25rem;\n\n  /* === Tooltip === */\n  --tooltip-bg: rgba(30, 35, 50, 0.98);\n  --tooltip-border: rgba(75, 85, 99, 0.3);\n  --tooltip-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);\n\n  /* === Transitions === */\n  --transition-fast: all 0.2s ease;\n  --transition-normal: all 0.3s ease;\n}\n\n/* ============================================\n   LAYOUT UTILITIES\n   ============================================ */\n.u-flex {\n  display: flex;\n}\n\n.u-flex-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.u-flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.u-flex-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.u-flex-wrap {\n  flex-wrap: wrap;\n}\n\n.u-items-center {\n  align-items: center;\n}\n\n.u-gap-xs {\n  gap: var(--space-xs);\n}\n\n.u-gap-sm {\n  gap: var(--space-sm);\n}\n\n.u-gap-md {\n  gap: var(--space-md);\n}\n\n.u-gap-lg {\n  gap: var(--space-lg);\n}\n\n.u-gap-xl {\n  gap: var(--space-xl);\n}\n\n/* ============================================\n   TEXT UTILITIES\n   ============================================ */\n.u-text-center {\n  text-align: center;\n}\n\n.u-text-right {\n  text-align: right;\n}\n\n.u-text-muted {\n  color: var(--color-text-muted);\n}\n\n.u-text-dim {\n  color: var(--color-text-dim);\n}\n\n.u-text-faint {\n  color: var(--color-text-faint);\n}\n\n.u-text-uppercase {\n  text-transform: uppercase;\n}\n\n.u-font-500 {\n  font-weight: 500;\n}\n\n.u-font-600 {\n  font-weight: 600;\n}\n\n/* ============================================\n   DISPLAY UTILITIES\n   ============================================ */\n.u-hidden {\n  display: none;\n}\n\n/* ============================================\n   STATE UTILITIES\n   (Empty, loading, and error states used\n   across multiple Models module components)\n   ============================================ */\n.u-empty-state {\n  padding: 20px;\n  text-align: center;\n  color: var(--color-text-disabled);\n}\n\n.u-error-state {\n  padding: 40px;\n  text-align: center;\n  color: var(--color-text-disabled);\n}\n\n/* ============================================\n   CHART TOOLTIP\n   (Shared across ModelMainChart and potentially\n   other chart components)\n   ============================================ */\n.chart-tooltip {\n  background: var(--tooltip-bg);\n  border: 1px solid var(--tooltip-border);\n  border-radius: var(--radius-md);\n  padding: 8px 12px;\n  box-shadow: var(--tooltip-shadow);\n  color: var(--color-text-primary);\n  font-size: 13px;\n  min-width: 280px;\n}\n\n.chart-tooltip__header {\n  margin-bottom: 6px;\n}\n\n.chart-tooltip__date {\n  color: var(--color-text-mid-gray);\n  font-size: 11px;\n  margin-top: 2px;\n}\n\n.chart-tooltip__row {\n  display: flex;\n  justify-content: space-between;\n  margin: 4px 0;\n}\n\n.chart-tooltip__label {\n  color: var(--color-text-mid-gray);\n}\n\n.chart-tooltip__value {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.chart-tooltip__value--open {\n  color: var(--color-chart-blue);\n}\n\n.chart-tooltip__value--high {\n  color: var(--color-chart-green);\n}\n\n.chart-tooltip__value--low {\n  color: var(--color-chart-red);\n}\n\n.chart-tooltip__value--close {\n  color: var(--color-chart-purple);\n}\n\n.chart-tooltip__value--volume {\n  color: var(--color-chart-cyan);\n}\n\n.chart-tooltip__separator {\n  margin: 8px 0 4px 0;\n  padding-top: 8px;\n  border-top: 1px solid var(--tooltip-border);\n}\n\n.chart-tooltip__main-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.chart-tooltip__main-row--bordered {\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgba(75, 85, 99, 0.2);\n}\n\n.chart-tooltip__name-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.chart-tooltip__value-group {\n  text-align: right;\n  margin-left: 12px;\n}\n\n.chart-tooltip__indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-circle);\n  flex-shrink: 0;\n}\n\n.chart-tooltip__name {\n  color: var(--color-text-bright-gray);\n  font-size: 13px;\n  font-weight: 400;\n}\n\n/* ============================================\n   DRAG STATE\n   (Shared drag-active class for drag-and-drop\n   interactions in ModelBuilder)\n   ============================================ */\n.drag-active {\n  border-color: var(--color-primary) !important;\n  background: rgba(139, 92, 246, 0.1) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
